import router from './index'
//获取vuex数据
import store from '../store/index'
const whiteList = ['/login', '/404','/demo']
//路由拦截
router.beforeEach(async (to, from, next) => {
	const hasToken = store.state.loginModule.userInfo.token;
	
	if (hasToken) { //已经登录
		if (to.path === '/login') {
			next({
				path: '/'
			}) //如果请求登录页直接跳主页
		} else { //B不是请求登录页
			const hasGetMenu = store.state.menuModule.asyncMenu;
			if (hasGetMenu.length > 0) {
				//console.log('有路由'+JSON.stringify(store.state.menuModule.asyncMenu))
				next()
			} else {
				try {
					console.log('没有路由,请求')
					await store.dispatch('menuModule/getMenu')
					// hack方法 确保addRoutes已完成,注意要添加 replace: true
					// 其实在路由守卫中，只有next()是放行，其他的诸如：next('/logon') 、 next(to) 或者 next({ ...to, replace: true })都不是放行，
					// 而是：中断当前导航，执行新的导航
					// next({ ...to, replace: true })中的replace: true只是一个设置信息，告诉VUE本次操作后，不能通过浏览器后退按钮，返回前一个路由。
					next({
						...to,
						replace: true
					})
					//next()
				} catch (error) {
					next('/login?redirect=${to.path}')
				}
			}
		}
	} else {
		///console.log('没有登录')//可以访问白名单
		if (whiteList.indexOf(to.path) !== -1) {
			next()
		} else { //跳转登录
			next('/login?redirect=${to.path}')
		}
	}
})